import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import _debounce from 'lodash/debounce';
import _clone from 'lodash/clone';
import ControlledBlurInput from './ControlledBlurInput';
/**
 * An input that only sends changes
 * to its parent on blur and maintains its own value while focused.
 */

var BlurInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BlurInput, _React$Component);

  function BlurInput(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: typeof _this.props.value !== 'undefined' ? _this.props.value : ''
    };
    _this.setInputElement = _this.setInputElement.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = BlurInput.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var autoComplete = this.props.autoComplete;
    var isAutoCompletePollingEnabled = !(/^(false|off)$/.test(autoComplete) || !autoComplete);
    var currentInputHasFocus = this.state.input === document.activeElement; // Input value should not update if autocomplete is on and the current input has focus.
    // Without this, changes to input fields as a result of an autocomplete trigger
    // a rerender which in turn resets inputs whose values have yet to set in state.
    // This filters when the value update should trigger a subsequent rerender.

    if (isAutoCompletePollingEnabled && currentInputHasFocus) {
      return;
    }

    this.setState({
      value: nextProps.value
    });
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return !_isEqual(nextProps, this.props) || !_isEqual(nextState, this.state) || this.props.value !== this.state.value;
  }
  /**
   * Used to retrieve current input from ControlledBlurInput
   */
  ;

  _proto.setInputElement = function setInputElement(input) {
    this.setState({
      input: input
    });
  }
  /**
   * DEPRECATED. This is an anti-pattern and should not be used.
   */
  ;

  _proto.value = function value() {
    return this.state.value;
  };

  _proto.handleChange = function handleChange(e) {
    this.setState({
      value: e.target.value
    });

    if (typeof this.props.debounceMs === 'number') {
      this.deb = this.deb || _debounce(this.props.onChange, this.props.debounceMs);
      this.deb(_clone(e));
    }

    e.stopPropagation();
  };

  _proto.handleBlur = function handleBlur(e) {
    if (this.props.value !== this.state.value) {
      this.props.onChange(e);
    }

    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        debounceMs = _this$props.debounceMs,
        inputProps = _objectWithoutProperties(_this$props, ["debounceMs"]); // eslint-disable-line no-unused-vars


    var props = Object.assign({}, inputProps, {
      value: this.state.value,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onSetInput: this.setInputElement
    });
    return /*#__PURE__*/React.createElement(ControlledBlurInput, props);
  };

  return BlurInput;
}(React.Component);

export { BlurInput as default };
BlurInput.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  debounceMs: PropTypes.number,
  textarea: PropTypes.bool,
  autoComplete: PropTypes.string
} : {};